/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  MetaCategorySuggestionControllerGetQueueItemQueryResponse,
  MetaCategorySuggestionControllerGetQueueItemPathParams,
  MetaCategorySuggestionControllerGetQueueItem401,
  MetaCategorySuggestionControllerGetQueueItem404,
} from '../types/MetaCategorySuggestionControllerGetQueueItem.ts';

function getMetaCategorySuggestionGetQueueItemUrl(
  queueId: MetaCategorySuggestionControllerGetQueueItemPathParams['queueId'],
) {
  const res = { method: 'GET', url: `/api/user/telegram/category/meta/suggestions/queue/${queueId}` as const };
  return res;
}

/**
 * {@link /api/user/telegram/category/meta/suggestions/queue/:queueId}
 */
export async function metaCategorySuggestionGetQueueItem(
  queueId: MetaCategorySuggestionControllerGetQueueItemPathParams['queueId'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    MetaCategorySuggestionControllerGetQueueItemQueryResponse,
    ResponseErrorConfig<
      MetaCategorySuggestionControllerGetQueueItem401 | MetaCategorySuggestionControllerGetQueueItem404
    >,
    unknown
  >({ method: 'GET', url: getMetaCategorySuggestionGetQueueItemUrl(queueId).url.toString(), ...requestConfig });
  return res.data;
}
